export default __webpack_public_path__ + "static/media/nodejs.cca10cac.svg";